// AUTO-GENERATED — DO NOT EDIT BY HAND.
// Source of truth: aol_schemas.conversation (aol-us-shared). Regenerate with
// `./devops build types` (emitter: aol_schemas/export_conversation.py).

export const MessageRole = {
  USER: 'user',
  ASSISTANT: 'assistant',
  TOOL: 'tool',
  SYSTEM: 'system',
  HUMAN_AGENT: 'human_agent',
} as const;
export type MessageRole = (typeof MessageRole)[keyof typeof MessageRole];

export const MessageType = {
  TEXT: 'text',
  AUDIO_TRANSCRIPT: 'audio_transcript',
  TOOL_CALL: 'tool_call',
  TOOL_RESULT: 'tool_result',
  AGENT_MESSAGE: 'agent_message',
} as const;
export type MessageType = (typeof MessageType)[keyof typeof MessageType];

export const ComponentType = {
  COURSE_BROWSER: 'course_browser',
  RAG_CONTENT: 'rag_content',
} as const;
export type ComponentType = (typeof ComponentType)[keyof typeof ComponentType];
